module.exports = __webpack_public_path__ + "CV.png?ae863437af0d56dda8698afa82b6cdb7";